<template>
    <div>
        <h2 class="text-center">แก้ไขตารางการทำงาน</h2>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">วันที่เริ่มเปลี่ยนกะ</div>
            <div class="col-6">
                <date-picker
                    v-model="form.date"
                    :format="changeFormat"
                    :lang="lang"
                    placeholder="วันที่เปลี่ยนกะ">
                </date-picker>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">พนักงาน</div>
            <div class="col-6">
                <multiselect
                    v-model="form.employee"
                    :options="optionEmployee"
                    :customLabel="employeeLabel"
                    :show-labels="false"
                    placeholder="เลือกพนักงาน"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">แผนก</div>
            <div class="col-6">
                <multiselect
                    v-model="form.department"
                    :options="optionDepartment"
                    label="department_name"
                    :show-labels="false"
                    :multiple="true"
                    placeholder="เลือกแผนก"
                    track-by="id">
                </multiselect>
            </div>
        </div>
        <b-row>
            <b-col sm="4" class="col-sm-4 text-right">
                <label>กะปัจจุบัน</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <multiselect
                    v-model="form.old_shift"
                    :options="optionShiftEmployee"
                    label="name"
                    :show-labels="false"
                    select-label=""
                    selectedLabel=""
                    deselectLabel=""
                    placeholder="เลือกกะการทำงาน"
                    track-by="id">
                </multiselect>
            </b-col>
        </b-row>
        &nbsp
        <b-row>
            <b-col sm="4" class="col-sm-4 text-right">
                <label>กะใหม่</label>
            </b-col>
            <b-col sm="6" class="col-sm-6">
                <multiselect
                    v-model="form.new_shift"
                    :options="optionShiftEmployee"
                    label="name"
                    :show-labels="false"
                    select-label=""
                    selectedLabel=""
                    deselectLabel=""
                    placeholder="เลือกกะการทำงานใหม่"
                    track-by="id">
                </multiselect>
            </b-col>
        </b-row>
        <br>
        <div class="row form-group">
            <div class="col-4 text-right">เวลาเริ่มต้นกะ</div>
            <div class="col-6">
                <b-form-select :options="optionWorkTime" v-model="form.start_work_time">
                </b-form-select>
            </div>
        </div>
        <div class="row form-group">
            <div class="col-4 text-right">เวลาสิ้นสุดกะ</div>
            <div class="col-6">
                <b-form-select :options="optionWorkTime"
                               v-model="form.end_work_time">
                </b-form-select>
            </div>
        </div>
        <br/>
        <div class="col text-center">
            <button type="button" @click="submitData"
                    class="btn btn-success">
                <icon name="save"></icon>
                บันทึก
            </button>&nbsp;&nbsp;
            <button type="button"
                    @click="cancelData"
                    class="btn btn-outline-secondary">
                <icon name="times"></icon>
                ยกเลิก
            </button>
        </div>
        <!--        <pre>{{optionDepartment}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect";
import moment from "moment"
import DatePicker from 'vue2-datepicker'

export default {
    name: "WorkScheduleHistoryModal",
    components: {
        Multiselect,
        DatePicker
    },
    created() {
        this.$store.dispatch("Employee/getEmployeeAll").then(res => {
            this.optionEmployee = res;
        });
        this.$store.dispatch("Common/getWorkTime").then(res => {
            this.optionWorkTime = [
                {text: 'เลือกเวลากะทำงาน', value: null},
                ...res.map(time => ({
                    value: time.work_time,
                    text: time.work_time,
                }))
            ]
        });
        this.getDepartmentAll();
    },
    computed: {
        ...mapState({
            optionShiftEmployee: state => {
                return state.Common.shift_work_employee
            },
            form: state => {
                return state.WorkScheduleHistory.form
            },
            user: state => {
                return state.Auth.user;
            },
        })
    },
    data() {
        return {
            optionWorkTime: [],
            optionEmployee: [],
            optionDepartment: [],
            changeFormat: {
                stringify: (date) => {
                    let date_moment = moment(date).format('YYYY');
                    const year = parseInt(date_moment) + 543;
                    //console.log(moment(date).format('DD/MM/'+year));
                    return date ? moment(date).format('DD/MM/' + year) : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
        }
    },
    methods: {
        getDepartmentAll() {
            this.$store.dispatch("Department/getAllDepartment").then(res => {
                this.optionDepartment = res;
            })
        },
        employeeLabel(option) {
            return `${option.employee_no} - ${option.name}`
        },
        submitData() {
            if (!this.form.old_shift) {
                alert("กรุณาเลือกกะที่ต้องการเปลี่ยน")
            } else if (!this.form.new_shift) {
                alert("กรุณาเลือกกะใหม่")
            } else if (!this.form.employee && !this.form.department.length) {
                alert("กรุณาเลือกพนักงานหรือแผนกที่ต้องการเปลี่ยนกะ")
            } else {
                let department_id = [];
                this.form.department.forEach(data => {
                    department_id.push(data.id);
                })
                let data = {
                    id: this.form.id,
                    date: this.form.date ? moment(this.form.date).format("YYYY-MM-DD") : '',
                    old_shift_work_id: this.form.old_shift ? this.form.old_shift.id : '',
                    new_shift_work_id: this.form.new_shift ? this.form.new_shift.id : '',
                    employee_id: this.form.employee ? this.form.employee.id : '',
                    start_work_time: this.form.start_work_time,
                    end_work_time: this.form.end_work_time,
                    user: this.user.id,
                    department_id: department_id,
                }
                this.$emit('submit', data);
            }
        },
        cancelData() {
            this.$emit('submit', false);
        }
    }
}
</script>

<style scoped>

</style>
